/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'

import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'

import {
  SEASON_GRID_HEADER_HEIGHT,
  SEASON_GRID_ROW_HEIGHT,
} from '../../constants'

const ROW_COUNT = 6

/** Cold-load placeholder for the season table: header band + rows. */
const SeasonStatsGridSkeleton = () => {
  'use memo'

  return (
    <div aria-hidden='true' css={wrapStyles}>
      <SkeletonRow height={SEASON_GRID_HEADER_HEIGHT} />
      {Array.from({ length: ROW_COUNT }, (_, i) => (
        <SkeletonRow key={i} height={SEASON_GRID_ROW_HEIGHT} />
      ))}
    </div>
  )
}

// ─── Styles ──────────────────────────────────────────────────────

const wrapStyles = css`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export default SeasonStatsGridSkeleton
